import { useSuspenseQuery } from '@tanstack/react-query';
import { orpc } from './orpc';

export const meQuery = () => orpc.me.get.queryOptions({ retry: false, staleTime: 60_000 });

/** The signed-in user. Only use below the `_app` route (its beforeLoad guarantees the data). */
export function useMe() {
  return useSuspenseQuery(meQuery()).data;
}

/** Only same-app relative paths: never an open redirect. */
export function safeRedirect(target: unknown): string {
  return typeof target === 'string' && target.startsWith('/') && !target.startsWith('//') && !target.startsWith('/\\') ? target : '/tickets';
}
